import { Text } from '@avanta/shared/components/Text';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronRight, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type Appointment } from 'types/appointments';
import { type LocationState } from './types';

interface EditAppointmentProps {
  appointment: Appointment;
  onSuccess: (state: LocationState) => void;
}

export const EditAppointmentDialog = ({
  appointment,
  onSuccess,
}: EditAppointmentProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const isEditEnabled = !appointment.immovable;

  const handleEditAppointment = (): void => {
    onSuccess({
      appointment,
      psychologist: appointment.psychologist?.psychologist,
      flow: FLOW_MODES.edit,
    });
  };

  if (!isEditEnabled) {
    return (
      <Dialog
        open
        title={t('EditSessionDialog.disabled.heading')}
        description={t('EditSessionDialog.disabled.body')}
      />
    );
  }

  return (
    <Dialog
      open
      title={t('EditSessionDialog.heading')}
      secondaryAction={{
        label: (
          <>
            <X className="size-6" />
            {t('EditSessionDialog.cancel')}
          </>
        ),
        variant: 'destructive_terciary',
        size: 'lg',
        icon: 'leading',
      }}
      primaryAction={{
        label: (
          <>
            {t('EditSessionDialog.confirm')}
            <ChevronRight className="size-6" />
          </>
        ),
        className: 'w-40',
        action: handleEditAppointment,
        variant: 'secondary',
        size: 'lg',
        icon: 'trailing',
      }}
    >
      <Text variant="text-md-regular" className="text-denim-500">
        {t('EditSessionDialog.body')}
      </Text>
    </Dialog>
  );
};
